/**
 * 
 * @returns 
 */
export const hellopanda_func = {

  /**
   * 문자열을 숫자로 반환
   * @param {*} string 
   * @returns 
   */
  getNumber(input) {
    let matches = String(input).match(/(\d+)/);
    return matches ? parseInt(matches[0], 10) : 0;
  },

  /**
   * 오브젝트가 있는지 체크 (비어있으면 true 반환)
   * @param {*} obj 
   * @returns 
   */
  isObjectEmpty (obj) {
    if (typeof obj === 'object') {
      return Object.keys(obj).length === 0;
    } else {
      return obj.length === 0;
    }
  },

  /**
   * 중복 클래스를 삭제하고 유일한 클래스만 배열로 추출
   * @param {*} attributes 
   * @param {*} mergeclass 
   * @returns 
   */
  mergeAttributeClass (attributes, mergeclass) {
    let newClassArray = attributes.className?.split(' ') || [];
    newClassArray = newClassArray.filter(item => {
      const found = mergeclass.find(option => option.value === item);
      return !found;
    });
    return newClassArray;
  },

  /**
   * core 에서 스타일로 적용할지 판단하는 배열 정의
   * @param {*} attributes 
   * @param {*} arr 
   * @returns 
   */
  getApplyAttribute (attributes, arr) {
    let hellopanda = Array.isArray(attributes.style?.hellopanda) ? attributes.style?.hellopanda : [];
    arr.forEach(item => {
      const key = Object.keys(item)[0]; // 객체의 첫 번째 키를 가져옴
      const value = item[key]; // 해당 키에 대응하는 값을 가져옴
      hellopanda = hellopanda?.filter(item => item != key);
      if (value && !this.isObjectEmpty(value)) {
        hellopanda.push(key);
      }
    });
    return hellopanda;
  },

  /**
   * 초기화 상태로 스타일을 리셋
   * @param {*} attributes 
   * @param {*} arr 
   * @param {*} newStyle 
   */
  removeApplyAttribute (attributes, arr, newStyle, store) {
    arr.forEach(item => {
      const key = Object.keys(item)[0]; // 객체의 첫 번째 키를 가져옴
      const value = item[key]; // 해당 키에 대응하는 값을 가져옴
      if (typeof newStyle.hellopanda === 'object' && !value) {
        newStyle.hellopanda = newStyle.hellopanda.filter(item => item !== key);
      }
      if (typeof store === 'object' && !value) {
        delete store[key];
      }
    });
    if (!newStyle?.hellopanda?.length) delete newStyle.hellopanda;
  },

  removeEmptyObject (obj) {
    const newObj = Array.isArray(obj) ? [] : {};
    for (const key in obj) {
      // Skip inherited properties
      if (!obj.hasOwnProperty(key)) continue;
      const value = obj[key];
      if (typeof value === 'object' && value !== null) {
        // Recursively call removeEmpty
        const cleanedValue = this.removeEmptyObject(value);
        if (Object.keys(cleanedValue).length > 0) {
          newObj[key] = cleanedValue;
        }
      } else if (value !== '' && value !== undefined && value !== null) {
        newObj[key] = value;
      }
    }
    return newObj;
  },

  /**
   * 순서 재 배합
   * @param {*} units 
   * @param {*} hint 
   * @returns 
   */
  prioritizeUnit (units, hint) {
    // hint에 매칭되는 항목을 첫 번째로 이동시키기
    let index = units.findIndex(unit => unit.value === hint);
    if (index !== -1) {
      let item = units.splice(index, 1)[0];
      units.unshift(item);
    }
  
    // default 값을 순서대로 재정의하기
    units.forEach((unit, idx) => {
      unit.default = idx + 1;
    });
  
    return units;
  },

  /**
   * EM 단위를 기본으로 하는 Unit
   * @returns 
   */
  getNewUnitArray (key = 'em') {

    let units = [
      { value: 'em', label: 'em', default: 1, step: .1 },
      { value: 'rem', label: 'rem', default: 2, step: .1 },
      { value: 'px', label: 'px', default: 3, step: 1 },
      { value: '%', label: '%', default: 4, step: .1 },
      { value: 'vw', label: 'vw', default: 5, step: .1 },
      { value: 'vh', label: 'vh', default: 6, step: .1 },
    ];
    units = this.prioritizeUnit(units, key);

    return units;
  },

  /**
   * 단위 수치를 clamp 형식으로 변환한다.
   * 5rem이 들어가면 대략 9vw 를 반환한다.
   * var(--wp--preset--spacing--70) = min(5.00rem, 9vw); ( block.json 설정에 근거하여 )
   * @param {*} input 
   * @returns 
   */
  calculateResponsive(input) {
    if (typeof input !== 'string') {
      return input;
    }
  
    const unitPattern = /(\d+(?:\.\d+)?)(em|rem|px|%|vw|vh)/;
    const match = input.match(unitPattern);
  
    if (!match) {
      return input;
    }
  
    const value = parseFloat(match[1]);
    const unit = match[2];
  
    // Only process em and rem units
    if (unit !== 'em' && unit !== 'rem') {
      return input;
    }
  
    // Fixed conversion: 5rem ≈ 9vw
    const vwEquivalentValue = (value / 5) * 10;
  
    return `min(${value}${unit}, ${vwEquivalentValue.toFixed(2)}vw)`;
  },

  /**
   * BoxControl 컴포넌트의 단위를 기본적으로 설정해준다.
   * @returns 
   */
  getDefaultUnitArray(obj) {
    if (obj !== null && typeof obj === 'object' && !Array.isArray(obj)) {
      const newObj = Object.assign({}, obj); // 객체의 얕은 복사 수행
      Object.keys(newObj).forEach(key => {
        let value = newObj[key];
        // if (typeof parseInt(value) === 'number' && !isNaN(parseFloat(value))) {
        //   value += this.getNewUnitArray()[0]?.value || 'px';
        // }
        newObj[key] = this.calculateResponsive(value);
      });
      return newObj;
    } else {
      return obj;
    }
  },

  /**
   * HEX에 투명도를 적용한다.
   * @param {*} hex 
   * @param {*} opacity 
   * @returns 
   */
  getHexToRGBA (hex, opacity) {
    // 입력된 투명도 값 (0~1)을 16진수로 변환
    const alphaHex = Math.round(opacity * 255).toString(16);
    // 변환된 16진수 값을 두 자리로 만듭니다.
    const paddedAlphaHex = ('0' + alphaHex).slice(-2);
    // 기존의 Hex 코드에 투명도 값을 추가하여 반환
    return hex + paddedAlphaHex;
  },

  /**
   * 두개의 오브젝트가 서로 같은지 체크
   * @param {*} a 
   * @param {*} b 
   * @returns 
   */
  isSameObject (a, b) {

    // 두 객체의 속성 개수가 다를 경우, 바로 false 반환
    if (Object.keys(a).length !== Object.keys(b).length) {
      return false;
    }

    // 각 속성을 하나씩 확인하면서 값이 일치하는지 확인
    for (let key in a) {
      // 두 객체의 해당 속성의 값이 다를 경우, 바로 false 반환
      if (a[key] !== b[key]) {
        return false;
      }
    }

    // 모든 속성이 동일하다면 true 반환
    return true;
  },

  /**
   * 스타일을 한줄로 리턴한다.
   * @param {*} content 
   * @returns 
   */
  trimStyle (content) {
    return content.trim().replace(/\s+/g, ' ');
  },

  /**
   * 리액트 오브젝트 스타일을 해석, 반환한다.
   * @param {*} style 
   * @returns 
   */
  objectToStyle (style) {
    const style_rule = wp.styleEngine.getCSSRules(style || {});
    const result = style_rule.reduce((acc, cur) => {
      acc[cur.key] = cur.value;
      return acc;
    }, {});

    return result;
  },

  /**
   * 구글 메테리얼 아이콘의 코드를 추출한다.
   * <span class="material-symbols-outlined">fullscreen</span> -> fullscreen
   * @param {*} str 
   * @returns 
   */
  getMaterialCode (str) {
    return str?.replace(/<[^>]*>/g, '')?.trim();
  },

  /**
   * 정규식을 사용하여 클래스명이 정확히 존재하는지 확인
   */
  hasClass (className, targetClass) {
    const regex = new RegExp(`(^|\\s)${targetClass}(\\s|$)`);
    return regex.test(className);
  },

  /**
   * 난수 생성
   * @param {*} length 
   * @returns 
   */
  randomString (length) {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  },

  /**
   * 난수 생성
   * @param {*} length 
   * @returns 
   */
  randomOnlyString (length) {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    let result = "";
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  },

  /**
   * CSS Minify 리턴
   * @param {*} css 
   * @returns 
   */
  minifyCSS (css) {
    return css
      .replace(/\s*({|}|;|:|,)\s*/g, '$1')  // Remove spaces around {} ; : ,
      .replace(/;\s*}/g, '}')              // Remove space before closing }
      .replace(/\s{2,}/g, ' ')             // Replace multiple spaces with single space
      .replace(/\/\*[\s\S]*?\*\//g, '');   // Remove comments
  },

  /**
   * 모바일 기기 환경 체크
   */
  isDeviceMobile () {

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    
    // iOS, Android, Windows Phone 체크
    if (/android/i.test(userAgent)) {
        return true; // Android 기기
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return true; // iOS 기기
    }

    if (/windows phone/i.test(userAgent)) {
        return true; // Windows Phone 기기
    }

    return false; // 모바일 환경이 아님 (데스크탑)

  }

}